@if (defaultsLoading()) {
  <app-loading [loading]="true" />
} @else if (defaultsError()) {
  <p role="alert">{{ defaultsError() | translate }}</p>
  <app-secondary-button title="Retry" icon="pi pi-refresh" (action)="reset()" />
} @else {
<div class="start-form">
  @if (hasInheritedDefaults()) {
    <small class="parameter-help full-width">{{ 'PROCESS_DEFAULTS_START_HELP' | translate }}</small>
  }
  @switch (kind()) {
    @case ('post-processing') {
      <msf-input
        class="full-width"
        [model]="form().satelliteProductId"
        (modelChange)="setSatelliteProductId($event)"
        [label]="'Satellite product ID'"
      ></msf-input>
      @if (satelliteProductAnalysisUrl(); as productUrl) {
        <app-copyable-identifier
          [value]="form().satelliteProductId"
          [link]="productUrl"
        ></app-copyable-identifier>
      }
      <label class="field">
        <span>{{ 'Priority' | translate }}</span>
        <msf-select
          [model]="form().priority"
          (modelChange)="setPriority($event)"
          [options]="priorityOptions"
          optionLabel="label"
          optionValue="id"
          translateBy="locale"
        ></msf-select>
      </label>
    }
    @case ('farmer-reports') {
      <msf-input
        [model]="form().maxReportsPerRun"
        (modelChange)="setMaxReportsPerRun($event)"
        type="number"
        step="1"
        [min]="1"
        [label]="'Max reports per run'"
      ></msf-input>
      <app-checkbox
        class="full-width"
        [ngModel]="form().alsoPdf"
        (ngModelChange)="setAlsoPdf($event)"
        label="Also generate PDF"
      ></app-checkbox>
    }
    @case ('bid-templates') {
      <div class="date-field">
        <label class="field">
          <span>{{ 'Start date' | translate }}</span>
          <msf-select
            [model]="startDateField().mode"
            (modelChange)="setStartDateMode($event)"
            [options]="datePlaceholderOptions"
            optionLabel="label"
            optionValue="id"
            translateBy="locale"
          ></msf-select>
        </label>
        @if (startDateField().showOffset) {
          <div class="date-offset">
            <msf-select
              [model]="startDateField().sign"
              (modelChange)="setStartDateSign($event)"
              [options]="dateSignOptions"
              optionLabel="label"
              optionValue="id"
            ></msf-select>
            <msf-input
              [model]="startDateField().amount"
              (modelChange)="setStartDateAmount($event)"
              type="number"
              step="1"
              [label]="'Date offset'"
            ></msf-input>
            <msf-select
              [model]="startDateField().unit"
              (modelChange)="setStartDateUnit($event)"
              [options]="dateUnitOptions"
              optionLabel="label"
              optionValue="id"
              translateBy="locale"
            ></msf-select>
          </div>
        }
        @if (startDateIsCalendar()) {
          <app-date-picker
            [ngModel]="form().startDate"
            (ngModelChange)="setStartDate($event)"
            [dateOnly]="true"
            [showClear]="true"
          ></app-date-picker>
        }
      </div>
      <div class="date-field">
        <label class="field">
          <span>{{ 'End date' | translate }}</span>
          <msf-select
            [model]="endDateField().mode"
            (modelChange)="setEndDateMode($event)"
            [options]="datePlaceholderOptions"
            optionLabel="label"
            optionValue="id"
            translateBy="locale"
          ></msf-select>
        </label>
        @if (endDateField().showOffset) {
          <div class="date-offset">
            <msf-select
              [model]="endDateField().sign"
              (modelChange)="setEndDateSign($event)"
              [options]="dateSignOptions"
              optionLabel="label"
              optionValue="id"
            ></msf-select>
            <msf-input
              [model]="endDateField().amount"
              (modelChange)="setEndDateAmount($event)"
              type="number"
              step="1"
              [label]="'Date offset'"
            ></msf-input>
            <msf-select
              [model]="endDateField().unit"
              (modelChange)="setEndDateUnit($event)"
              [options]="dateUnitOptions"
              optionLabel="label"
              optionValue="id"
              translateBy="locale"
            ></msf-select>
          </div>
        }
        @if (endDateIsCalendar()) {
          <app-date-picker
            [ngModel]="form().endDate"
            (ngModelChange)="setEndDate($event)"
            [dateOnly]="true"
            [showClear]="true"
          ></app-date-picker>
        }
      </div>
      <msf-input
        [model]="form().locale"
        (modelChange)="setLocale($event)"
        [label]="'Locale'"
      ></msf-input>
      <msf-input
        [model]="form().bucket"
        (modelChange)="setBucket($event)"
        [label]="'Bucket'"
      ></msf-input>
    }
    @case ('catch-up') {
      <msf-input
        [model]="form().catchUpTake"
        (modelChange)="setCatchUpTake($event)"
        type="number"
        step="1"
        [min]="1"
        [label]="'Products per catch-up run'"
      ></msf-input>
    }
    @case ('probe') {
      <msf-input
        [model]="form().failEvery"
        (modelChange)="setFailEvery($event)"
        type="number"
        step="1"
        [min]="1"
        [label]="'Fail every N runs'"
      ></msf-input>
    }
    @case ('season-indices') {
      @if (showFieldId()) {
        <label class="field full-width">
          <span>{{ 'Field' | translate }}</span>
          <msf-select-paginated
            [model]="form().fieldId"
            (modelChange)="setFieldId($event)"
            [service]="fieldService"
            serviceMethod="cropMonitoringFieldGetByQueryPost"
            optionLabel="name"
            optionValue="id"
            searchBy="name"
            [translateBy]="null"
            [showClear]="true"
            [placeholder]="'Select field' | translate"
          ></msf-select-paginated>
        </label>
        <small class="parameter-help full-width">
          {{ 'Season indices field recalc help' | translate }}
        </small>
      }
      <div class="date-field">
        <label class="field">
          <span>{{ 'Date from' | translate }}</span>
          <msf-select
            [model]="startDateField().mode"
            (modelChange)="setStartDateMode($event)"
            [options]="datePlaceholderOptions"
            optionLabel="label"
            optionValue="id"
            translateBy="locale"
          ></msf-select>
        </label>
        @if (startDateField().showOffset) {
          <div class="date-offset">
            <msf-select
              [model]="startDateField().sign"
              (modelChange)="setStartDateSign($event)"
              [options]="dateSignOptions"
              optionLabel="label"
              optionValue="id"
            ></msf-select>
            <msf-input
              [model]="startDateField().amount"
              (modelChange)="setStartDateAmount($event)"
              type="number"
              step="1"
              [label]="'Date offset'"
            ></msf-input>
            <msf-select
              [model]="startDateField().unit"
              (modelChange)="setStartDateUnit($event)"
              [options]="dateUnitOptions"
              optionLabel="label"
              optionValue="id"
              translateBy="locale"
            ></msf-select>
          </div>
        }
        @if (startDateIsCalendar()) {
          <app-date-picker
            [ngModel]="form().startDate"
            (ngModelChange)="setStartDate($event)"
            [dateOnly]="true"
            [showClear]="true"
          ></app-date-picker>
        }
      </div>
      <div class="date-field">
        <label class="field">
          <span>{{ 'Date to' | translate }}</span>
          <msf-select
            [model]="endDateField().mode"
            (modelChange)="setEndDateMode($event)"
            [options]="datePlaceholderOptions"
            optionLabel="label"
            optionValue="id"
            translateBy="locale"
          ></msf-select>
        </label>
        @if (endDateField().showOffset) {
          <div class="date-offset">
            <msf-select
              [model]="endDateField().sign"
              (modelChange)="setEndDateSign($event)"
              [options]="dateSignOptions"
              optionLabel="label"
              optionValue="id"
            ></msf-select>
            <msf-input
              [model]="endDateField().amount"
              (modelChange)="setEndDateAmount($event)"
              type="number"
              step="1"
              [label]="'Date offset'"
            ></msf-input>
            <msf-select
              [model]="endDateField().unit"
              (modelChange)="setEndDateUnit($event)"
              [options]="dateUnitOptions"
              optionLabel="label"
              optionValue="id"
              translateBy="locale"
            ></msf-select>
          </div>
        }
        @if (endDateIsCalendar()) {
          <app-date-picker
            [ngModel]="form().endDate"
            (ngModelChange)="setEndDate($event)"
            [dateOnly]="true"
            [showClear]="true"
          ></app-date-picker>
        }
      </div>
      @if (showDetectionJob()) {
        <msf-input
          class="full-width"
          [model]="form().polygonDetectionJobId"
          (modelChange)="setPolygonDetectionJobId($event)"
          [label]="'DETECTION_JOB'"
        ></msf-input>
        <small class="parameter-help full-width">
          {{ 'SEASON_INDICES_DETECTION_JOB_HELP' | translate }}
        </small>
      }
      @if (showForce()) {
        <app-checkbox
          class="full-width"
          [ngModel]="form().forceSeasonIndices"
          (ngModelChange)="setForceSeasonIndices($event)"
          label="Force re-aggregation"
        ></app-checkbox>
      }
    }
    @case ('fields') {
      @for (field of parameterFieldViews(); track field.name) {
        @switch (field.type) {
          @case ('date') {
            <div class="date-field">
              <label class="field">
                <span>{{ field.labelKey | translate }}</span>
                <msf-select
                  [model]="field.date?.mode"
                  (modelChange)="setParameterDateMode(field.name, $event)"
                  [options]="datePlaceholderOptions"
                  optionLabel="label"
                  optionValue="id"
                  translateBy="locale"
                ></msf-select>
              </label>
              @if (field.date?.showOffset) {
                <div class="date-offset">
                  <msf-select
                    [model]="field.date?.sign"
                    (modelChange)="setParameterDateSign(field.name, $event)"
                    [options]="dateSignOptions"
                    optionLabel="label"
                    optionValue="id"
                  ></msf-select>
                  <msf-input
                    [model]="field.date?.amount"
                    (modelChange)="setParameterDateAmount(field.name, $event)"
                    type="number"
                    step="1"
                    [label]="'Date offset'"
                  ></msf-input>
                  <msf-select
                    [model]="field.date?.unit"
                    (modelChange)="setParameterDateUnit(field.name, $event)"
                    [options]="dateUnitOptions"
                    optionLabel="label"
                    optionValue="id"
                    translateBy="locale"
                  ></msf-select>
                </div>
              }
              @if (field.calendar) {
                <app-date-picker
                  [ngModel]="field.value || null"
                  (ngModelChange)="setParameterDate(field.name, $event)"
                  [dateOnly]="true"
                  [showClear]="true"
                ></app-date-picker>
              }
            </div>
          }
          @case ('checkbox') {
            <app-checkbox
              class="full-width"
              [ngModel]="field.checked"
              (ngModelChange)="setParameterChecked(field.name, $event)"
              [label]="field.labelKey"
            ></app-checkbox>
          }
          @case ('number') {
            <msf-input
              [model]="field.value"
              (modelChange)="setParameterField(field.name, $event)"
              type="number"
              [min]="field.min ?? -1000000000"
              [label]="field.labelKey"
            ></msf-input>
          }
          @case ('select') {
            <label class="field">
              <span>{{ field.labelKey | translate }}</span>
              <msf-select
                [model]="field.value"
                (modelChange)="setParameterField(field.name, $event)"
                [options]="field.options"
                optionLabel="label"
                optionValue="id"
                translateBy="locale"
              ></msf-select>
            </label>
          }
          @case ('regions') {
            <app-region-dictionary-select
              class="full-width"
              [label]="field.labelKey"
              [model]="field.regions"
              (modelChange)="setParameterRegions(field.name, $event)"
            ></app-region-dictionary-select>
          }
          @case ('field') {
            <label class="field full-width">
              <span>{{ field.labelKey | translate }}</span>
              <msf-select-paginated
                [model]="field.value"
                (modelChange)="setParameterField(field.name, $event)"
                [service]="fieldService"
                serviceMethod="cropMonitoringFieldGetByQueryPost"
                optionLabel="name"
                optionValue="id"
                searchBy="name"
                [translateBy]="null"
                [showClear]="true"
                [placeholder]="'Select field' | translate"
              ></msf-select-paginated>
            </label>
          }
          @case ('polygon') {
            <app-textarea
              class="full-width"
              [ngModel]="field.value"
              (ngModelChange)="setParameterField(field.name, $event)"
              [label]="field.labelKey"
              [rows]="8"
              [showCharacterCount]="false"
            ></app-textarea>
          }
          @case ('checks') {
            <div class="providers full-width">
              <span>{{ field.labelKey | translate }}</span>
              @for (option of field.options; track option.id) {
                <app-checkbox
                  [ngModel]="option.selected"
                  (ngModelChange)="setParameterCheck(field.name, option.id, $event)"
                  [label]="option.label"
                ></app-checkbox>
              }
            </div>
          }
          @default {
            <msf-input
              [model]="field.value"
              (modelChange)="setParameterField(field.name, $event)"
              [label]="field.labelKey"
            ></msf-input>
          }
        }
        @if (field.helpKey) {
          <small class="parameter-help full-width">{{ field.helpKey | translate }}</small>
        }
      }
    }
    @case ('json') {
      <app-textarea
        class="full-width"
        [ngModel]="form().parametersJson"
        (ngModelChange)="setParametersJson($event)"
        [label]="'Process parameters (JSON)'"
        [rows]="15"
        [showCharacterCount]="false"
      ></app-textarea>
      @if (!parameterHelp()) {
        <small class="parameter-help full-width">
          {{ 'Assignment date placeholder help' | translate }}
          <code>{{ datePlaceholderExamples }}</code>
        </small>
      }
    }
    @default {
      @if (!hideAssignmentName()) {
        <msf-input
          [model]="form().name"
          (modelChange)="setName($event)"
          [label]="'Assignment name'"
        ></msf-input>
      }
      <label class="field">
        <span>{{ 'Search area' | translate }}</span>
        <msf-select
          [model]="form().geometrySource"
          (modelChange)="setGeometrySource($event)"
          [options]="geometryOptions"
          optionLabel="label"
          optionValue="id"
          translateBy="locale"
        ></msf-select>
      </label>
      @if (showCountryName()) {
        <msf-input
          [model]="form().countryName"
          (modelChange)="setCountryName($event)"
          [label]="'Country name'"
        ></msf-input>
      }
      @if (showRegionIds()) {
        <app-region-dictionary-select
          class="full-width"
          [label]="'Regions'"
          [model]="form().regionIds"
          (modelChange)="setRegionIds($event)"
        ></app-region-dictionary-select>
      }
      @if (showGeoJson()) {
        <app-orchestration-geometry-map
          class="full-width"
          [geoJson]="form().geoJson"
          (geoJsonChange)="setGeoJsonFromMap($event)"
        ></app-orchestration-geometry-map>
        <app-textarea
          class="full-width"
          [ngModel]="form().geoJson"
          (ngModelChange)="setGeoJson($event)"
          [label]="'Polygon GeoJSON'"
          [rows]="7"
          [showCharacterCount]="false"
        ></app-textarea>
      }
      @if (showGeoJsonFile()) {
        <msf-input
          [model]="form().geoJsonFileId"
          (modelChange)="setGeoJsonFileId($event)"
          [label]="'GeoJSON file ID'"
        ></msf-input>
      }
      <div class="date-field">
        <label class="field">
          <span>{{ 'Start date' | translate }}</span>
          <msf-select
            [model]="startDateField().mode"
            (modelChange)="setStartDateMode($event)"
            [options]="datePlaceholderOptions"
            optionLabel="label"
            optionValue="id"
            translateBy="locale"
          ></msf-select>
        </label>
        @if (startDateField().showOffset) {
          <div class="date-offset">
            <msf-select
              [model]="startDateField().sign"
              (modelChange)="setStartDateSign($event)"
              [options]="dateSignOptions"
              optionLabel="label"
              optionValue="id"
            ></msf-select>
            <msf-input
              [model]="startDateField().amount"
              (modelChange)="setStartDateAmount($event)"
              type="number"
              step="1"
              [label]="'Date offset'"
            ></msf-input>
            <msf-select
              [model]="startDateField().unit"
              (modelChange)="setStartDateUnit($event)"
              [options]="dateUnitOptions"
              optionLabel="label"
              optionValue="id"
              translateBy="locale"
            ></msf-select>
          </div>
        }
        @if (startDateIsCalendar()) {
          <app-date-picker
            [ngModel]="form().startDate"
            (ngModelChange)="setStartDate($event)"
            [dateOnly]="true"
            [showClear]="true"
          ></app-date-picker>
        }
      </div>
      <div class="date-field">
        <label class="field">
          <span>{{ 'End date' | translate }}</span>
          <msf-select
            [model]="endDateField().mode"
            (modelChange)="setEndDateMode($event)"
            [options]="datePlaceholderOptions"
            optionLabel="label"
            optionValue="id"
            translateBy="locale"
          ></msf-select>
        </label>
        @if (endDateField().showOffset) {
          <div class="date-offset">
            <msf-select
              [model]="endDateField().sign"
              (modelChange)="setEndDateSign($event)"
              [options]="dateSignOptions"
              optionLabel="label"
              optionValue="id"
            ></msf-select>
            <msf-input
              [model]="endDateField().amount"
              (modelChange)="setEndDateAmount($event)"
              type="number"
              step="1"
              [label]="'Date offset'"
            ></msf-input>
            <msf-select
              [model]="endDateField().unit"
              (modelChange)="setEndDateUnit($event)"
              [options]="dateUnitOptions"
              optionLabel="label"
              optionValue="id"
              translateBy="locale"
            ></msf-select>
          </div>
        }
        @if (endDateIsCalendar()) {
          <app-date-picker
            [ngModel]="form().endDate"
            (ngModelChange)="setEndDate($event)"
            [dateOnly]="true"
            [showClear]="true"
          ></app-date-picker>
        }
      </div>
      <div class="providers">
        <span>{{ 'Providers' | translate }}</span>
        <app-checkbox
          [ngModel]="form().sentinel"
          (ngModelChange)="setSentinel($event)"
          label="Sentinel-2"
        ></app-checkbox>
        <app-checkbox
          [ngModel]="form().landsat"
          (ngModelChange)="setLandsat($event)"
          label="Landsat"
        ></app-checkbox>
      </div>
      <label class="field">
        <span>{{ 'Priority' | translate }}</span>
        <msf-select
          [model]="form().priority"
          (modelChange)="setPriority($event)"
          [options]="priorityOptions"
          optionLabel="label"
          optionValue="id"
          translateBy="locale"
        ></msf-select>
      </label>
      @if (showCloudCover()) {
        <msf-input
          [model]="form().maximumCloudCover"
          (modelChange)="setCloudCover($event)"
          type="number"
          [label]="'Maximum cloud cover'"
        ></msf-input>
      }
    }
  }
  @if (parameterHelp(); as help) {
    <div class="parameter-help full-width">
      @for (example of help.examples; track example.titleKey) {
        <p>{{ example.titleKey | translate }}</p>
        <pre><code>{{ example.json }}</code></pre>
      }
      <ul>
        @for (parameterKey of help.parameterKeys; track parameterKey) {
          <li>{{ parameterKey | translate }}</li>
        }
      </ul>
    </div>
  }
</div>
@if (validationError()) {
  <p class="parameter-help" role="alert">{{ validationError() | translate }}</p>
}
}
